// Hirá: moves the progress line under the mobile product gallery as the slides are swiped.
class HiraMobileGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.hira-mgallery__track');
    this.thumb = this.querySelector('.hira-mgallery__thumb');
    if (!this.track || !this.thumb) return;

    this.count = this.track.children.length;
    this.frame = 0;
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    };
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const progress = max > 0 ? this.track.scrollLeft / max : 0;
    // Thumb is 1/count of the line; slide it across by (count - 1) of its own widths.
    this.thumb.style.transform = `translateX(${progress * (this.count - 1) * 100}%)`;
  }
}

if (!customElements.get('hira-mobile-gallery')) {
  customElements.define('hira-mobile-gallery', HiraMobileGallery);
}
